import { CellGroup, CellItem } from "@/components/cell";
import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";
import { APP_ROUTES } from "@/constants/app-routes";
import { RecreatePlanCell } from "./recreate-plan-cell";

export default function MyPreferencesSettingsPage() {
  return (
    <PageContainer
      showLogo={true}
      bgColor="background-gray"
      className="app-bar-bottom-padding no-scrollbar h-full items-start overflow-y-auto"
      headerBgColor="background-gray"
      contentBgColor="background-gray"
    >
      <PageTitleComponent title="My Preferences" />
      <CellGroup title="Lifestyle">
        <CellItem label="Supermarket" href="/settings/lifestyle/supermarket" />
        {/* <CellItem label="Breakfast" href="/settings/lifestyle/breakfast" />
        <CellItem label="Lunch" href="/settings/lifestyle/lunch" />
        <CellItem label="Dinner" href="/settings/lifestyle/dinner" /> */}
      </CellGroup>
      <CellGroup title="Food Preferences">
        <CellItem label="Allergies" href="/settings/food-preference/allergies" />
        <CellItem label="Foods you don't like" href="/settings/food-preference/food-avoids" />
        <CellItem label="Cuisines" href="/settings/food-preference/cuisines" />
        <CellItem
          label="Dietary Requirement"
          href="/settings/food-preference/dietary-requirement"
        />
      </CellGroup>
      {/* <CellGroup title="Food Profile"> */}
      {/* <CellItem label="My Food Profile" href="/profiling/food" /> */}
      {/* <CellItem label="Go to Profile" href="/profiling/go-to" /> */}
      {/* <CellItem label="My Favourites" href="/profiling/favourites" /> */}
      {/* </CellGroup> */}
      <CellGroup title="Other Settings">
        <CellItem label="Start Onboarding Process Again" href={APP_ROUTES.ONBOARDING_START} />
        <RecreatePlanCell />
      </CellGroup>
    </PageContainer>
  );
}
